module.exports = __webpack_public_path__ + "img/oracle.cfd52b04.svg";